enum TipoFiltroDataVenda {
    DataAprovacao = 1,
    FaturamentoParcial = 2,
    FaturamentoCompleto = 3,
}

export default TipoFiltroDataVenda;
